module.exports = __webpack_public_path__ + "media/images/car_icon-a3b1473b2f6c475b8b503ce54f27bacd.png";